var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-top-bar"},[_c('c-main-info'),_c('c-login-selector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }